import React, { useContext, Suspense } from 'react';
import DynamicLayout from '../components/DynamicLayout';
import { PlatformContext } from '../context/PlatformContext';
import { MobileComponents, DesktopComponents, LoadingComponent } from '../helpers/platformUtils';
import NoIndexHelmet from '../components/NoIndexHelmet';

const InboxPage = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <NoIndexHelmet title="Messages | Saturnalia" />
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';
  const MobileComponent = MobileComponents.Messages;
  const DesktopComponent = DesktopComponents.Messages;

  return (
    <DynamicLayout>
      <NoIndexHelmet title="Messages | Saturnalia" />
      <Suspense fallback={<LoadingComponent />}>
        {isMobile ? (
          <MobileComponent />
        ) : (
          <DesktopComponent />
        )}
      </Suspense>
    </DynamicLayout>
  );
};

export default InboxPage;
